import { render } from "./CalendarMapTestPage.vue?vue&type=template&id=f3078f24&ts=true"
import script from "./CalendarMapTestPage.vue?vue&type=script&lang=ts"
export * from "./CalendarMapTestPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__